<div class="container-fluid">
  <app-header titleText="Customer Quote and Contact Report" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
        <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null" class="container">
    <div class="row">
      <h5 class="col-sm-12" i18n>Please provide report criteria</h5>
    </div>
  </div>
  <div *ngIf="report">
    <div class="row header-text">

      <div class="col-md-4">
          <app-dealer-logo></app-dealer-logo>
      </div>
      <div class="col-md-6 filter-zone">
        <p>
          <span i18n>REPORT DEFINED:</span><br />
          <span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br />
          <ng-template [ngIf]="customer"><span i18n>Customer:</span> {{customer.customer_BusinessName}}<br /></ng-template>
          <ng-template [ngIf]="displayFormat"><span i18n>Format:</span> {{displayFormat}}<br /></ng-template>
        </p>
      </div>

    </div>

    <div class="content">
      <div *ngIf="parameters.displayFormat" class="quote-annual-summary">
        <h2 i18n>Quotes</h2>
        <table class="table table-bidit">
            <thead>
                <tr>
                    <th *ngIf="!parameters.customer_ID" i18n>Customer</th>
                    <th i18n>Project Name</th>
                    <th i18n>Quote Amount</th>
                    <th i18n>Quote Status</th>
                    <th i18n>Date Created</th>
                    <th i18n>Salesperson</th>
                    <th i18n>View</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let quote of report.quotes">
                    <td *ngIf="!parameters.customer_ID">
                        {{quote.customer.customer_BusinessName}}
                    </td>
                    <td>{{quote.quote_Name}}</td>
                    <td>
                        <ng-template [ngIf]="quote.quote_BidAmount">
                            ${{quote.quote_BidAmount | number: '1.2-2'}}
                        </ng-template>
                    </td>
                    <td>{{quote.quoteStatus}}</td>
                    <td>{{quote.quote_Created | date: 'M/d/yyyy'}}</td>
                    <td>
                        <div>
                            <div *ngFor="let assignment of quote.quoteAssignments">
                                {{assignment.assignedTo.firstName}} {{assignment.assignedTo.lastName}}
                            </div>
                        </div>
                    </td>
                    <td>
                        <a routerLink="/quote/{{quote.quote_ID}}" class="btn btn-bidit-submit" i18n>View</a>
                    </td>
                </tr>
            </tbody>
        </table>
      </div>

      <div class="quote-month-summary">
        <h2 i18n>Contacts</h2>
        <div>
          <table class="table table-bidit">
              <thead>
                  <tr>
                      <th *ngIf="!parameters.customer_ID" i18n>Customer</th>
                      <th i18n>Contact Name</th>
                      <th i18n>Contact Type</th>
                      <th i18n>Phone #</th>
                      <th i18n>Cell #</th>
                      <th i18n>Email</th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let contact of report.contacts">
                      <td *ngIf="!parameters.customer_ID">
                          {{contact.customer_BusinessName}}
                      </td>
                      <td>{{contact.contact_FirstName}} {{contact.contact_LastName}}</td>
                      <td>
                          <ng-template [ngIf]="contact.contactType">
                              {{contact.contactType.contactType_Desc}}
                          </ng-template>
                      </td>
                      <td>{{contact.contact_Phone}}</td>
                      <td>{{contact.contact_Mobile}}</td>
                      <td>{{contact.contact_Email}}</td>
                  </tr>
              </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
